import React from 'react';
import { useTranslation } from '../../i18n';

const HelpPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', color: 'var(--text-primary)' }}>
      <h2 style={{
        fontSize: '2.5rem',
        marginBottom: '2rem',
        textAlign: 'center',
        color: 'var(--color-primary)',
      }}>
        {t('menu.support.title')}
      </h2>

      <div style={{
        backgroundColor: `rgba(var(--color-primary-rgb), 0.15)`,
        backdropFilter: 'blur(10px)',
        borderRadius: '15px',
        padding: '2rem',
        marginBottom: '2rem',
        lineHeight: '1.8',
        border: `2px solid var(--color-primary)`,
      }}>
        <h3 style={{
          fontSize: '1.5rem',
          marginBottom: '1rem',
          color: 'var(--color-accent)',
        }}>
          {t('menu.support.sectionTitle')}
        </h3>

        <div style={{ marginBottom: '2rem' }}>
          <h4 style={{
            fontSize: '1.2rem',
            marginBottom: '0.5rem',
            color: 'var(--color-accent)',
          }}>
            {t('menu.support.gameNotWorkingTitle')}
          </h4>
          <p style={{
            color: 'var(--text-secondary)',
            marginBottom: '1.5rem',
          }}>
            {t('menu.support.gameNotWorkingBody')}
          </p>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <h4 style={{
            fontSize: '1.2rem',
            marginBottom: '0.5rem',
            color: 'var(--color-accent)',
          }}>
            {t('menu.support.suggestionTitle')}
          </h4>
          <p style={{
            color: 'var(--text-secondary)',
            marginBottom: '1.5rem',
          }}>
            {t('menu.support.suggestionBody')}
          </p>
        </div>
      </div>

      <div style={{
        backgroundColor: `rgba(var(--color-primary-rgb), 0.15)`,
        backdropFilter: 'blur(10px)',
        borderRadius: '15px',
        padding: '2rem',
        textAlign: 'center',
        border: `2px solid var(--color-primary)`,
      }}>
        <h3 style={{
          fontSize: '1.5rem',
          marginBottom: '1rem',
          color: 'var(--color-accent)',
        }}>
          {t('menu.support.needMoreHelpTitle')}
        </h3>
        <p style={{
          color: 'var(--text-secondary)',
          marginBottom: '1rem',
        }}>
          {t('menu.support.needMoreHelpBody')}
        </p>
        <p style={{
          color: 'var(--text-muted)',
          fontSize: '0.9rem',
        }}>
          {t('menu.support.supportEmail')}
        </p>
      </div>
    </div>
  );
};

export default HelpPage;
